import React, { useContext, useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Login, RecoverPassword, Register, ChangePassword, Profile,
        Store, Webhooks, NewArticle, ActiveArticles,
        Facturas, NuevaFacrura, OrdenVenta, NewOrdenVenta, NotFound,
        Items,  ExtraUpdate, OrdenCompra, NewOrdenCompra, AdminUsuarios, CuentaSuspendida
        } from './page';
import { Footer, Navbar, CustomSidebar, FacturacionDetallada, CompraDetallada, VentaDetallada, ArticuloDetallada } from './components';
import './App.css';
import { DataContext } from './contex/DataContext';
import ProtectedRoute from './utils/ProtectedRoute';
import { buildApiUrl } from './config/api';

function App() {
  const { ambiente, role } = useContext(DataContext);
  const location = useLocation();
  const navigate = useNavigate();

  // Definir las rutas donde no quieres mostrar el sidebar
  const hideSidebarRoutes = ['/', '/recoverPassword', '/register', '/changePassword', '/cuenta-suspendida'];

  // Verificar si la ruta actual está en la lista de rutas donde no mostrar el sidebar
  const shouldHideSidebar = hideSidebarRoutes.includes(location.pathname) || location.key === 'default' || location.pathname === '*';

  const error404 = location.key === 'default' || location.pathname === '*';
  const isSuspendedPage = location.pathname === '/cuenta-suspendida';

  const containerStyle = (path) => {
    const hiddenOverflowPaths = ['/new-article', '/nueva-factura', '/new-orden-venta','/new-orden-compra'];

    if (path.startsWith('/facturas/')) {
      return { flex: 1 };
    }
    if (path.startsWith('/active-articles/')) {
      return { flex: 1 };
    }
    if (path.startsWith('/orden-compra/')) {
      return { flex: 1 };
    }
    if (path.startsWith('/orden-venta/')) {
      return { flex: 1 };
    }
  
    if (hiddenOverflowPaths.includes(path)) {
      return { flex: 1, overflow: 'visible', position: 'relative'   };
    }
  
    return { flex: 1, overflowY: 'auto', overflowX: 'none' };/*  overflow: 'hidden' */
  };

  useEffect(() => {
    const organizationID = localStorage.getItem('organizationID');
    const storedRole = localStorage.getItem('role');
    if (['/', '/recoverPassword', '/register', '/changePassword'].includes(location.pathname) && organizationID) {
      navigate(storedRole === 'admin' ? '/admin/usuarios' : '/store');
    }
  }, [location.pathname, navigate]);

  // Verifica si la cuenta está suspendida y, de ser así, redirige a la página de bloqueo
  useEffect(() => {
    const organizationID = localStorage.getItem('organizationID');
    if (!organizationID || location.pathname === '/cuenta-suspendida') return;

    const checkSuspended = async () => {
      try {
        const res = await axios.get(buildApiUrl('/ep_UserEcart/GetProfile'), {
          params: { OrganizationID: organizationID },
        });

        if (res.data?.ServiceStatus === 'suspendido') {
          navigate('/cuenta-suspendida');
        }
      } catch (error) {
        console.log('Error al verificar el status de la cuenta:', error);
      }
    };

    checkSuspended();
  }, [location.pathname, navigate]);

  return (
    <div className='app-conatiner'>
      {!error404 && !isSuspendedPage && <Navbar />}
      
      <div style={{ display: 'flex', marginTop: '20px', height:'100vh'}}>
        {!shouldHideSidebar && <CustomSidebar ambiente={ambiente} role={role} />}
        <div style={containerStyle(location.pathname)}>
          <Routes>
            <Route exact path="/" element={<Login />} />
            <Route exact path="/recoverPassword" element={<RecoverPassword />} />
            <Route exact path="/register" element={<Register />} />
            <Route exact path="/changePassword" element={<ChangePassword />} />

            <Route
              exact
              path="/store"
              element={
                <ProtectedRoute>
                  <Store />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/webhooks"
              element={
                <ProtectedRoute>
                  <Webhooks />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/extraUpdate"
              element={
                <ProtectedRoute>
                  <ExtraUpdate />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/items"
              element={
                <ProtectedRoute>
                  <Items />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/new-article"
              element={
                <ProtectedRoute>
                  <NewArticle />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/active-articles"
              element={
                <ProtectedRoute>
                  <ActiveArticles />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/active-articles/:id"
              element={
                <ProtectedRoute>
                  <ArticuloDetallada />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/facturas"
              element={
                <ProtectedRoute>
                  <Facturas />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/facturas/:id" 
              element={
                <ProtectedRoute>
                  <FacturacionDetallada />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/nueva-factura"
              element={
                <ProtectedRoute>
                  <NuevaFacrura />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/orden-venta"
              element={
                <ProtectedRoute>
                  <OrdenVenta />
                </ProtectedRoute>
              }
            />  
            <Route
              exact
              path="/orden-venta/:id" 
              element={
                <ProtectedRoute>
                  <VentaDetallada />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/new-orden-venta"
              element={
                <ProtectedRoute>
                  <NewOrdenVenta />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/orden-compra"
              element={
                <ProtectedRoute>
                  <OrdenCompra />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/orden-compra/:id" 
              element={
                <ProtectedRoute>
                  <CompraDetallada />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/new-orden-compra"
              element={
                <ProtectedRoute>
                  <NewOrdenCompra />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/admin/usuarios"
              element={
                <ProtectedRoute requiredRole="admin">
                  <AdminUsuarios />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/cuenta-suspendida"
              element={
                <ProtectedRoute>
                  <CuentaSuspendida />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
      <div style={{ maxWidth: '100vw' }}>
        <Footer />
      </div>
    </div>
  );
}

export default App;
